import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _sortBy from "lodash/sortBy";
import _get from "lodash/get";
import _throttle from "lodash/throttle";
import "core-js/modules/es6.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CardImage from './card-image';
import './compare-card-images.less';

var CompareCardImages = /*#__PURE__*/function (_React$Component) {
  _inherits(CompareCardImages, _React$Component);

  var _super = _createSuper(CompareCardImages);

  function CompareCardImages(props) {
    var _this;

    _classCallCheck(this, CompareCardImages);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "refOuterContainer", function (e) {
      return _this.cardImagesOuterContainer = e;
    });

    _defineProperty(_assertThisInitialized(_this), "refInnerContainer", function (e) {
      return _this.cardImagesInnerContainer = e;
    });

    _defineProperty(_assertThisInitialized(_this), "refCardImage", function (e) {
      return _this.cardImages = e;
    });

    _defineProperty(_assertThisInitialized(_this), "handleDelete", function (cardId) {
      _this.props.removeFromCompare(cardId, 'compare-card-image-remove');

      _this.handleScroll();
    });

    _this.state = {
      showFadeLeft: false,
      showFadeRight: false
    };
    _this.handleScroll = _throttle(_this.handleScroll.bind(_assertThisInitialized(_this)), 150, {
      leading: true,
      trailing: true
    });
    return _this;
  }

  _createClass(CompareCardImages, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('load', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
      this.cardImagesOuterContainer.addEventListener('scroll', this.handleScroll);
      this.cardImagesInnerContainer.addEventListener('scroll', this.handleScroll);
      this.cardImages.addEventListener('scroll', this.handleScroll);
      this.isMountedThrottleCheck = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('load', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
      this.cardImagesOuterContainer.removeEventListener('scroll', this.handleScroll);
      this.cardImagesInnerContainer.removeEventListener('scroll', this.handleScroll);
      this.cardImages.removeEventListener('scroll', this.handleScroll);
      this.isMountedThrottleCheck = false;
    }
  }, {
    key: "getClassNames",
    value: function getClassNames() {
      return classnames('card-images-container-outer', {
        'fade-left': this.state.showFadeLeft,
        'fade-right': this.state.showFadeRight
      });
    }
  }, {
    key: "handleScroll",
    value: // eslint-disable-line no-return-assign
    // eslint-disable-next-line react/sort-comp -- directive added automatically by Shepherd migration
    function handleScroll() {
      /**
       * Since we are running our event listeners behind trailing edge throttle, it's possible
       * this function is fired after the component has been removed from the dom.
       */
      if (!this.isMountedThrottleCheck) {
        return;
      }

      var element = this.cardImages;

      var scrollWidth = _get(element, 'scrollWidth', -1);

      var scrollLeft = _get(element, 'scrollLeft', -1);

      var offsetWidth = _get(element, 'offsetWidth', -1);

      var newFadeLeft = scrollLeft > 0;
      var newFadeRight = scrollLeft + offsetWidth < scrollWidth;

      if (this.state.showFadeLeft !== newFadeLeft || this.state.showFadeRight !== newFadeRight) {
        this.setState({
          showFadeLeft: newFadeLeft,
          showFadeRight: newFadeRight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var cardObjects = this.props.cardsToCompare; // Note: reverse cards array to match compare page.

      var cards = _sortBy(this.props.cardIDsToCompare.reverse().map(function (id) {
        return cardObjects[id];
      }), 'card_name');

      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassNames(),
        ref: this.refOuterContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: "card-images-container-inner",
        ref: this.refInnerContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: "card-images",
        ref: this.refCardImage
      }, cards.map(function (card, idx) {
        return /*#__PURE__*/React.createElement(CardImage, {
          card: card,
          key: "card-".concat(idx),
          handleDelete: this.handleDelete
        });
      }, this))));
    }
  }]);

  return CompareCardImages;
}(React.Component);

_defineProperty(CompareCardImages, "propTypes", {
  cardIDsToCompare: PropTypes.arrayOf(PropTypes.number),
  // eslint-disable-next-line react/forbid-prop-types
  cardsToCompare: PropTypes.objectOf(PropTypes.object),
  removeFromCompare: PropTypes.func.isRequired
});

_defineProperty(CompareCardImages, "defaultProps", {
  cardIDsToCompare: [],
  cardsToCompare: {}
});

export { CompareCardImages as default };